module.exports = __webpack_public_path__ + "img/logo.230b9c2a.png";